import Tools from './tools';

export default class Nav {
  constructor() {
  	// Nav
  }
}